module.exports = __webpack_public_path__ + "static/img/process.f98eaef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/process.png
// module id = L57L
// module chunks = 0